import styled from 'styled-components';

export const Container = styled.div`
  margin-block: 24px;
`;

export const ErrorMessage = styled.span`
  box-sizing: border-box;
  margin: 0;
  min-width: 0;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  padding-left: 4px;
  color: #b00020;
`;
